// 1. Movie Project
import movie01 from "./project01-movie/movie01.png";
import movie02 from "./project01-movie/movie02.png";
import movie03 from "./project01-movie/movie03.png";

// 2. Hows Project
import hows01 from "./project02-hows/hows01.png";
import hows02 from "./project02-hows/hows02.png";
import hows03 from "./project02-hows/hows03.png";
import hows04 from "./project02-hows/hows04.png";
import hows05 from "./project02-hows/hows05.png";

// 3. nbti Project
import nbti01 from "./project03-nbti/nbti01.png";
import nbti02 from "./project03-nbti/nbti02.png";
import nbti03 from "./project03-nbti/nbti03.png";
import nbti04 from "./project03-nbti/nbti04.png";
import nbti05 from "./project03-nbti/nbti05.png";
import nbti06 from "./project03-nbti/nbti06.png";

// 4. nbti Project

// 5. crypto Project
import crypto01 from "./project05-crypto/crypto01.png";
import crypto02 from "./project05-crypto/crypto02.png";
import crypto03 from "./project05-crypto/crypto03.png";
import crypto04 from "./project05-crypto/crypto04.png";

// 6. gentlemonster Project
import gentlemonster01 from "./project06-gentlemonster/gentlemonster01.png";
import gentlemonster02 from "./project06-gentlemonster/gentlemonster02.png";
import gentlemonster03 from "./project06-gentlemonster/gentlemonster03.png";
import gentlemonster04 from "./project06-gentlemonster/gentlemonster04.png";
import gentlemonster05 from "./project06-gentlemonster/gentlemonster05.png";
import gentlemonster06 from "./project06-gentlemonster/gentlemonster06.png";

// 7. elemental Project
import elemental01 from "./project07-elemental/elemental01.png";
import elemental02 from "./project07-elemental/elemental02.png";
import elemental03 from "./project07-elemental/elemental03.png";
import elemental04 from "./project07-elemental/elemental04.png";

// 8. locknlock Project
import locknlock01 from "./project08-locknlock/locknlock01.png";
import locknlock02 from "./project08-locknlock/locknlock02.png";
import locknlock03 from "./project08-locknlock/locknlock03.png";
import locknlock04 from "./project08-locknlock/locknlock04.png";
import locknlock05 from "./project08-locknlock/locknlock05.png";

// 9. CJ ONE Project
import cjone01 from "./project09-cjone/cjone01.png";
import cjone02 from "./project09-cjone/cjone02.png";
import cjone03 from "./project09-cjone/cjone03.png";
import cjone04 from "./project09-cjone/cjone04.png";
import cjone05 from "./project09-cjone/cjone05.png";

// 10. Samsung Project
import samsung01 from "./project10-samsung/samsung01.png";
import samsung02 from "./project10-samsung/samsung02.png";
import samsung03 from "./project10-samsung/samsung03.png";
import samsung04 from "./project10-samsung/samsung04.png";
import samsung05 from "./project10-samsung/samsung05.png";
import samsung06 from "./project10-samsung/samsung06.png";

// 내보내기 
export const movieImgs = [movie01, movie02, movie03];
export const howsImgs = [hows01, hows02, hows03, hows04, hows05];
export const nbtiImgs = [nbti01, nbti02, nbti03, nbti04, nbti05, nbti06];
export const cryptoImgs = [crypto01, crypto02, crypto03, crypto04];
export const gentlemonsterImgs = [
  gentlemonster01,
  gentlemonster02,
  gentlemonster03,
  gentlemonster04,
  gentlemonster05,
  gentlemonster06,
];
export const elementalImgs = [elemental01, elemental02, elemental03, elemental04];
export const locknlockImgs = [
  locknlock01,
  locknlock02,
  locknlock03,
  locknlock04,
  locknlock05,
];
export const cjoneImgs = [cjone01, cjone02, cjone03, cjone04, cjone05];
export const samsungImgs = [
  samsung01,
  samsung02,
  samsung03,
  samsung04,
  samsung05,
  samsung06,
];